<template>
  <div>
    <v-dialog v-model="isUploading" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>{{ title }}</span>
          <v-btn text icon dark @click="isUploading = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <Upload v-bind="$attrs" @uploaded="handleUpload" />
        </v-container>
      </v-card>
    </v-dialog>

    <v-card>
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">Documents</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-btn @click="isUploading = true" color="primary" v-if="uploadDocs">
          <v-icon>mdi-file-document-box-plus-outline</v-icon>Upload
        </v-btn>
      </v-toolbar>
      <v-data-table
        :items="documents"
        :headers="headers"
        :options="{ sortBy: ['updated_at'], sortDesc: true }"
      >
        <template slot="item.status" slot-scope="{ item }">
          <v-icon v-if="item.status === 'uploaded'" color="success">mdi-progress-check</v-icon>
          <v-icon v-else color="warning">mdi-progress-upload</v-icon>
          <span class="ml-2">{{ item.status | title }}</span>
        </template>
        <template slot="item.updated_at" slot-scope="{ item }">{{
          item.updated_at | date
        }}</template>

        <template slot="item.action" slot-scope="{ item }">
          <document-actions :file="item" :deleteDocs="deleteDocs" @destroyed="removeFile(item)" />
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import DocumentActions from "./actions";
import Upload from "./upload";
import { deleteArrayEntry } from "@/store/utils";
export default {
  components: { Upload, DocumentActions },
  props: {
    dataDocuments: { required: true },
    title: { required: false, type: String, default: "Upload document" },
    uploadDocs: { required: false, type: Boolean, default: true },
    deleteDocs: { required: false, type: Boolean, default: true },
  },
  data() {
    return {
      isUploading: false,
      documents: this.dataDocuments,
      headers: this.pairTableLabelWithValue({
        Type: "type",
        Name: "name",
        Status: "status",
        Date: "updated_at",
        Action: "action",
      }),
    };
  },
  methods: {
    handleUpload(response) {
      this.isUploading = false;
      Notify.success("File was uploaded successfully");
      this.documents.unshift(response.document);
    },

    removeFile(file) {
      this.documents = deleteArrayEntry(this.documents, file, "id");
    },
  },
};
</script>
